<template>
  <div :class="{ 'mb-4': !compact }">
    <!-- Skeleton -->
    <div v-if="isLoadingEmp" class="card border-0 shadow-sm">
      <div class="card-body py-3">
        <div class="row">
          <div v-for="n in 4" :key="n" :class="compact ? 'col-12 mb-2' : 'col-md-3 col-6'">
            <div class="skeleton skeleton-text mb-1" style="width: 50%; height: 12px;"></div>
            <div class="skeleton skeleton-text" style="width: 80%; height: 16px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Card -->
    <div v-else class="card border-0 shadow-sm emp-card" :class="{ 'emp-card-compact': compact }">
      <div class="card-body py-3 px-4">
        <div class="row align-items-center">
              <div :class="compact ? 'col-12 mb-2' : 'col-md-2 col-6 mb-2 mb-md-0'">
                <p class="emp-label mb-2"><i class="fe fe-user mr-1"></i>Full Name</p>
                <h6 class="emp-value mb-0">{{ emp?.name || "-" }}</h6>
              </div>
              <div :class="[compact ? 'col-12 mb-2' : 'col-md-2 col-6 mb-2 mb-md-0', 'emp-field']">
                <p class="emp-label mb-2"><i class="fe fe-credit-card mr-1"></i>NIK</p>
                <h6 class="emp-value mb-0">{{ emp?.nik || "-" }}</h6>
              </div>
              <div :class="[compact ? 'col-12 mb-2' : 'col-md-4 col-6 mb-2 mb-md-0', 'emp-field']">
                <p class="emp-label mb-2"><i class="fe fe-briefcase mr-1"></i>Division</p>
                <h6 class="emp-value mb-0">{{ emp?.division || "-" }}</h6>
              </div>
              <div :class="[compact ? 'col-12' : 'col-md-4 col-6', 'emp-field']">
                <p class="emp-label mb-2"><i class="fe fe-award mr-1"></i>Position</p>
                <h6 class="emp-value mb-0">{{ emp?.position || "-" }}</h6>
              </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmpCard",
  props: {
    emp: {
      type: Object,
      required: true,
    },
    isLoadingEmp: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
};
</script>

<style scoped>
.emp-card {
  border-left: 4px solid #a12529 !important;
}

.emp-card-compact {
  min-height: 88px;
}

.emp-field {
  border-left: 1px solid #f1f3f5;
  padding-left: 1rem;
}

.emp-card-compact .emp-field {
  border-left: 0;
  border-top: 1px solid #f1f3f5;
  padding-left: 15px;
  padding-top: 0.75rem;
}

.emp-label {
  font-size: 0.75rem;
  color: #95aac9;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 500;
}

.emp-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #12263f;
}

/* Skeleton loader */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 4px;
  display: block;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
